// extracted by mini-css-extract-plugin
export default {"wrapper":"Discounts_wrapper__Uwauh","discountWrapper":"Discounts_discountWrapper__YR4fo","discountHeader":"Discounts_discountHeader__lEGbo"};